import { Button } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setMenuTitle } from "../../redux/slices/common_slice";

const CreateProfileHeader = ({
  handlePreviousStep,
  step,
  IS_FINAL,
  isEdit,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  return (
    <div
      className={`row header-row-inner mx-0 align-items-center ${
        step != 0 && !IS_FINAL
          ? "justify-content-between"
          : "justify-content-end"
      }`}
    >
      {step != 0 && !IS_FINAL && (
        <Button
          className="previous-btn w-auto d-flex align-items-center border-0 shadow-none rounded-0 bg-transparent"
          onClick={handlePreviousStep}
        >
          <img
            src="/assets/images/icons/back-arrow-gray-icon.svg"
            className="img-fluid"
            alt=""
          />
          {t("prevQues")}
        </Button>
      )}
      {!isEdit && (
        <Button
          className="setting-btn"
          onClick={() => {
            navigate("/settings/resources");
            dispatch(setMenuTitle(t("settings.resources")));
          }}
        >
          <img
            src="/assets/images/icons/hamburger-menu-icon.svg"
            alt=""
            className="img-fluid"
          />
        </Button>
      )}
    </div>
  );
};

export default CreateProfileHeader;
